import { AwsRum } from 'aws-rum-web';
import logger from 'loglevel';

logger.setDefaultLevel(logger.levels.INFO);

const awsRumHelper = () => {
    try {
        const runtimeEnvironment = import.meta.env.VITE_RUNTIME_ENVIRONMENT || 'development';
        if (runtimeEnvironment === 'development') {
            return;
        }
        
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "us-east-1:50c6363b-7882-4513-8c0d-7aeca250f010",
            endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
            telemetries: ["performance", "errors", "http"],
            allowCookies: true,
            enableXRay: false
        };

        const APPLICATION_ID = import.meta.env.VITE_RUM_APPLICATION_ID || undefined;
        if (!APPLICATION_ID) {
            return; // Cannot initialize AWS RUM without an application ID
        }
        
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'us-east-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
        
        return awsRum;
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}

/**
 * Ship Log level error messages to AWS RUM as errors (because we are capturing Js errors with try...catch...log)
 * @param awsRum {AwsRum}
 */
const logLevelSendErrorsToAwsRum = (awsRum) => {
    const originalFactory = logger.methodFactory;
    logger.methodFactory = (methodName, logLevel, loggerName) => {
        const rawMethod = originalFactory(methodName, logLevel, loggerName);

        return (...args) => {
            if (methodName === 'error') {
                const message = Array.from(args).map(x => `${x}`).join(' ');
                awsRum.recordError(message);
            }

            rawMethod(...args);
        };
    };
    logger.rebuild();  // Rebuild the logger to apply the new methodFactory
}

(() => {
    const awsRum = awsRumHelper();
    if (awsRum) {
        logLevelSendErrorsToAwsRum(awsRum);
    }    
    window.awsRum = awsRum;
})();